function LoginHeader() {
  return (
    <div className="sm:mx-auto sm:w-full sm:max-w-md mb-8 -mt-4">
      <img
        className="mx-auto w-[300px]"
        src="/images/main-logo.png"
        alt="Logo"
      />
    </div>
  );
}

export default LoginHeader;
